exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.time-picker-dialog--wrapper--3M_oXEDy {\n  width: 300px;\n  margin: 0 auto;\n}\n\n.time-picker-dialog--input--1WB1w3l4 {\n  display: inline-block;\n  margin: 0 10px;\n}\n\n.time-picker-dialog--input--1WB1w3l4 input {\n  text-align: center;\n  width: 100px;\n  font-size: 30px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/time-picker-dialog.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;CAChB;;AAED;EACE,sBAAsB;EACtB,eAAe;CAChB;;AAED;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;CACjB","file":"time-picker-dialog.css","sourcesContent":["\n.wrapper {\n  width: 300px;\n  margin: 0 auto;\n}\n\n.input {\n  display: inline-block;\n  margin: 0 10px;\n}\n\n.input input {\n  text-align: center;\n  width: 100px;\n  font-size: 30px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"wrapper": "time-picker-dialog--wrapper--3M_oXEDy",
	"input": "time-picker-dialog--input--1WB1w3l4"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/time-picker-dialog.css
// module id = 2258
// module chunks = 4